<template>
  <div :class="`${BASE_SELECTOR}`">
    <div :class="`${BASE_SELECTOR}__text`">
      {{ text }}

      <span :class="`${BASE_SELECTOR}__reduction`">
        {{ reduction }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfiguratorCrossSellPromotionTag',
  props: {
    text: {
      type: String,
      required: true,
    },
    reduction: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      BASE_SELECTOR: 'configurator-cross-sell-promotion-tag',
    };
  },
};
</script>

<style lang="scss" scoped>
.configurator-cross-sell-promotion-tag {
  display: flex;
  color: $color-arapawa;
  gap: 0.625rem;
  padding: 0.1875rem;
  border-radius: 0.3125rem;
  background-color: $color-blue-blizzard;
  width: fit-content;
  font-size: 1rem;

  &__reduction {
    color: $color-white;
    font-size: 1.125rem;
    font-weight: 900;
    font-family: $font-big-shoulders;
    padding: 0.1875rem 0.375rem;
    border-radius: 0.3125rem;
    background-color: $color-red-amaranth;
    display: inline-block;
  }
}
</style>
